<template>
  <div>
    <div class="wrap password-trans-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>비밀번호 변경</h3>
      </div>
      <div class="body-wrap">
        <h4 v-if="isAccount == 1" class="mb-20">
          계정이 확인되었습니다.<br />
          비밀번호를 재설정하여 재로그인 해주세요.<br />
          비밀번호는 영문+숫자+특수문자 (8자 이상) 입력해 주세요.
        </h4>

        <ul>
          <!-- <h4 class="bold">현재 비밀번호</h4> -->
          <!-- <li>
                        <input type="password" placeholder="현재 비밀번호를 입력하세요" v-model="input.currentPassword" @keyup="keyupEvent">
                    </li> -->
          <!-- 현재 비밀번호 입력이 틀렸을 경우 -->
          <!-- <p class="txt-red" v-if="isCurrentPass">현재 비밀번호와 일치하지 않습니다.</p> -->

          <h4 class="bold mt-30">새 비밀번호</h4>
          <li>
            <input
              type="password"
              placeholder="새로운 비밀번호를 입력해 주세요."
              v-model="input.newPassword"
              @keyup="keyupEvent"
            />
          </li>
          <p class="txt-red" v-if="isPass">영문+숫자+특수문자 8자리 이상으로 입력해 주세요.</p>

          <h4 class="bold mt-30">비밀번호 확인</h4>
          <li>
            <input
              type="password"
              placeholder="비밀번호를 한번 더 입력해주세요."
              v-model="input.newPasswordChk"
              @keyup="keyupEvent"
            />
          </li>
          <!-- 비밀번호가 제대로 입력되지 않았을 경우 -->
          <p class="txt-red" v-if="isPassChk">동일한 비밀번호를 입력해 주세요.</p>
        </ul>
      </div>
      <div class="bnb-btn bnb-btn-static">
        <!-- 비밀번호 입력 시 class="active" 활성화 -->
        <button :class="{ active: isActive }" @click="passwordTrans()">비밀번호 변경하기</button>
      </div>
    </div>
  </div>
</template>
<script>
import { EmptyCheck, PWFormatCheck } from "@/utils/validation";
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "password_trans",
  props: {
    idx: {
      type: [Number, String],
      default: 0,
    },
    isAccount: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    input: {
      currentPassword: "",
      newPassword: "",
      newPasswordChk: "",
    },
    isActive: false,
    isCurrentPass: false,
    isPass: false,
    isPassChk: false,
    userIdx: 0,
  }),
  components: {
    incBack,
  },
  mounted() {
    this.userIdx = Number(atob(this.idx));
  },
  methods: {
    keyupEvent() {
      if (this.input.newPassword != "" && this.input.newPasswordChk) {
        this.isActive = true;
      }
    },
    passwordTrans() {
      if (this.isActive) {
        if (!EmptyCheck(this.input.newPassword, "비밀번호를") || !EmptyCheck(this.input.newPasswordChk, "비밀번호를")) {
          return false;
        }
        if (!PWFormatCheck(this.input.newPassword)) {
          this.isPass = true;
          return false;
        } else {
          this.isPass = false;
        }
        if (this.input.newPassword != this.input.newPasswordChk) {
          this.isPassChk = true;
          return false;
        } else {
          this.isPassChk = false;
        }
        let form = new FormData();
        form.append("UserPassword", this.input.newPassword);
        form.append("userIdx", this.userIdx);
        this.axios
          .post("/front/user-pwupdate", form)
          .then((res) => {
            if (res.data.success) {
              if (res.data.message == "현재비밀번호 에러") {
                this.isCurrentPass = true;
              } else {
                localStorage.clear();
                alert("계정확인 및 비밀번호가 재설정 되었습니다. 다시 로그인해 주세요.");
                this.$router.push("/");
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped>
.bnb-btn-static {
  position: static;
  padding-bottom: 30px;
}
</style>
